import * as React from 'react';

const Truck = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="33"
    height="32"
    viewBox="0 0 33 32"
    fill="none"
    {...props}
  >
    <mask
      id="mask0_18977_71929"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="33"
      height="32"
    >
      <rect x="0.333496" width="32" height="32" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_18977_71929)">
      <path
        d="M8.12542 26.077C7.08453 26.077 6.20086 25.713 5.47442 24.985C4.74797 24.257 4.38475 23.3731 4.38475 22.3333H3.33342C2.99208 22.3333 2.70586 22.2179 2.47475 21.987C2.24386 21.7559 2.12842 21.4697 2.12842 21.1283V8.41033C2.12842 7.73678 2.36175 7.16667 2.82842 6.7C3.29508 6.23333 3.86508 6 4.53842 6H20.2821C20.945 6 21.5124 6.236 21.9844 6.708C22.4564 7.18 22.6924 7.74744 22.6924 8.41033V11.077H25.0258C25.4073 11.077 25.7689 11.1623 26.1104 11.333C26.4518 11.5037 26.7329 11.7397 26.9538 12.041L30.2974 16.518C30.3779 16.6184 30.4382 16.7289 30.4784 16.8493C30.5184 16.97 30.5384 17.1006 30.5384 17.241V21.1283C30.5384 21.4697 30.423 21.7559 30.1921 21.987C29.961 22.2179 29.6748 22.3333 29.3334 22.3333H28.1284C28.1284 23.3731 27.7641 24.257 27.0354 24.985C26.307 25.713 25.4224 26.077 24.3818 26.077C23.3411 26.077 22.4574 25.713 21.7308 24.985C21.0043 24.257 20.6411 23.3731 20.6411 22.3333H11.8718C11.8718 23.376 11.5075 24.2606 10.7791 24.987C10.0506 25.7137 9.16609 26.077 8.12542 26.077ZM8.12842 24.077C8.61731 24.077 9.03009 23.9086 9.36675 23.5717C9.70342 23.235 9.87175 22.8222 9.87175 22.3333C9.87175 21.8444 9.70342 21.4316 9.36675 21.0947C9.03009 20.758 8.61731 20.5897 8.12842 20.5897C7.63953 20.5897 7.22664 20.758 6.88975 21.0947C6.55308 21.4316 6.38475 21.8444 6.38475 22.3333C6.38475 22.8222 6.55308 23.235 6.88975 23.5717C7.22664 23.9086 7.63953 24.077 8.12842 24.077ZM24.3848 24.077C24.8736 24.077 25.2864 23.9086 25.6231 23.5717C25.96 23.235 26.1284 22.8222 26.1284 22.3333C26.1284 21.8444 25.96 21.4316 25.6231 21.0947C25.2864 20.758 24.8736 20.5897 24.3848 20.5897C23.8959 20.5897 23.483 20.758 23.1461 21.0947C22.8094 21.4316 22.6411 21.8444 22.6411 22.3333C22.6411 22.8222 22.8094 23.235 23.1461 23.5717C23.483 23.9086 23.8959 24.077 24.3848 24.077ZM22.6924 17.6667H28.6668L25.3334 13.2437C25.2908 13.1923 25.2416 13.1517 25.1861 13.1217C25.1305 13.0919 25.0685 13.077 25.0001 13.077H22.6924V17.6667Z"
        fill="#1C1B1F"
      />
    </g>
  </svg>
);

export default React.memo(Truck);
